import { ENV } from 'common/constants';

// CDN 域名
// export const CDN_DOMAIN = isBrowser
//   ? window?.DOMAINS?.CDN_DOMAIN || window?.__DOMAINS__?.CDN_DOMAIN || 'cloudcache.tencent-cloud.com'
//   : 'cloudcache.tencent-cloud.com';
export const CDN_DOMAIN = 'cloudcache.tencent-cloud.com';
export const NEW_CDN_DOMAIN =  process.env
  && (process.env.NODE_ENV === 'development' || process.env.ZONE_ENV === ENV.DEV || process.env.ZONE_ENV === ENV.TEST)
  ? 'test-staticintl.cloudcachetci.com'
  : 'staticintl.cloudcachetci.com'; // 针对ars下线，cdn新域名
export const NEW_CDN_ROOT = `https://${NEW_CDN_DOMAIN}/qcloud/intl/`;

/**
 * 生成需要的各种相对域名（控制台、购买页等）
 * @param  {String} host 基础host
 * @return {Object} 各类域名
 * @author easonlchen
 */
export const BASE_DOMAINS = {
  QCMAIN_HOST: 'www.tencentcloud.com',
  QCLOUD_ROOT_HOST: 'cloud.tencent.com',
  QCCONSOLE_HOST: 'console.tencentcloud.com',
  QCCONSOLE_CN_HOST: 'console.cloud.tencent.com',
  QCBUY_HOST: 'buy.tencentcloud.com',
  QCBUY_CN_HOST: 'buy.cloud.tencent.com',
  BASE_HOST: '.cloud.tencent.com',
  ROOT_HOSTS: ['cloud.tencent.com', 'tencentcloud.com'],
};

export const MAX_AGE_FOR_LOCALE_COOKIE = 180 * 24 * 3600 * 1000; // 180天

export const KEY_HOME = 'home';
export const KEY_DOCUMENT = 'document';
export const KEY_MARKET = 'market';
export const KEY_RENDER = 'render';
export const KEY_ASK = 'ask';
export const KEY_LANG = 'lang';
export const KEY_LANGUAGE = 'language';
export const KEY_INTL_LANGUAGE = 'intl_language';
export const KEY_INTL_PREVIEW = 'intl_preview';
export const KEY_PREVIEW = '!preview';
export const KEY_LONG_PREVIEW = '!longPreview';
export const KEY_NEXT_PREVIEW = '__prerender_bypass';
export const KEY_NEXT_PREVIEW_DATA = '__next_preview_data';
export const KEY_REDIRECT_PATH_NAME = [
  'render',
  'config',
  'pricing',
  'campaign',
  'products',
  'solutions',
  'partner',
  'customers',
  'edu',
  'services',
];
export const KEY_ANNOUNCE_PATH_NAME = 'announce';
export const KEY_DASHBOARD_PATH_NAME = 'dashboard';

// 微信分享 JD SDK 链接
export const WECHAT_JS_SDK_CDN_URL = `https://${CDN_DOMAIN}/qcloud/main/scripts/release/common/deps/wechatJsSdk.js?version=1_0_1&max_age=31536000`;

export const DOMAIN = {
  [ENV.DEVELOPMENT]: 'http://127.0.0.1:3000',
  [ENV.PRODUCTION]: 'https://www.tencentcloud.com',
  [ENV.DEV]: 'http://11.141.215.222:3000', // portal-main tkex-dev 11.141.215.222
  [ENV.TEST]: 'http://11.168.87.185',
  [ENV.PRE]: 'http://30.184.73.22:3000', // portal-main tkex-pre 30.184.73.22
  [ENV.PROD]: 'http://30.166.95.175:3000', // portal-main tkex-prod(hk1) 30.166.95.175
};

export const API_TAG = 'api';
export const API_MID_TAG = 'mid';
export const API_PROXY_TAG = 'proxy';
export const API_PREFIX = `/${API_TAG}/${API_MID_TAG}`; // /api/mid
export const API_PROXY_PREFIX = `/${API_TAG}/${API_MID_TAG}/${API_PROXY_TAG}`; // /api/mid/proxy

export const FETCH_PREFIX_MAP = {
  [API_MID_TAG]: API_PREFIX,
  [API_PROXY_TAG]: API_PROXY_PREFIX,
};

export const OPM_LIST_TAG = 'opm.getList';
export const OPM_DETAIL_TAG = 'opm.getDetail';

// cos CDN 域名
// export const COS_CDN_DOMAIN = 'main.qcloudimg.com';

// export const ROUTE_BASE_PATH = '';

// 腾讯云防水墙App Id
// export const T_CAPTCHA_ID = '2070586963';

// export const USER_LANGUAGE = runtime.language === 'jp' ? 'ja' : runtime.language;

// 通用错误码
// export * from './service-errors';

// 通用文档元信息
// export * from './meta';
